/**
 * iter77 — Render a user-facing display name that respects the deletion state
 * of the underlying account.
 *
 * Backend stores an English placeholder ("Deleted user") whenever a
 * document is anonymised (`author_id_anon: true` or `owner_id_anon: true`).
 * The viewer's locale takes precedence: whenever the flag is set we render
 * the localised label from the current i18n dictionary, so a French user
 * sees "Utilisateur supprimé" even though the DB row is stored in EN.
 *
 * `t` is the translator returned by `useI18n()`.
 */
export function displayAuthorName(item, t, key = "author_name") {
  if (!item) return "";
  const anon = item.author_id_anon || item.owner_id_anon || item.user_deleted || item.reporter_deleted;
  if (anon) return t("deleted_user_label");
  return item[key] || t("deleted_user_label");
}

export function displayAuthorPicture(item, key = "author_picture") {
  if (!item) return null;
  if (item.author_id_anon || item.owner_id_anon || item.user_deleted) return null;
  return item[key] || null;
}
